import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PrinterClass } from 'src/app/domain/printerClass/printer-class';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-delete-printer-class-dialog',
  templateUrl: './delete-printer-class-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    TranslateModule
  ],
  styleUrls: ['./delete-printer-class-dialog.component.css']
})
export class DeletePrinterClassDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeletePrinterClassDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrinterClass) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
